export const API_BASE_URL = window.REACT_APP_API_GATEWAY_URL;
export const PARKIT_API_BASE_URL = window.REACT_APP_PARKIT_API_BASE_URL;
export const REPORTING_API_BASE_URL = window.REACT_APP_REPORTING_API_BASE_URL || window.REACT_APP_API_GATEWAY_URL;
export const KEYCLOAK_BASE_URL = window.REACT_APP_KEYCLOAK_BASE_URL;
export const ELASTIC_SEARCH_TOKEN = window.REACT_APP_ELASTIC_SEARCH_TOKEN;
export const ROUTE_OPTIMIZER_URL = window.REACT_APP_ROUTE_OPTIMIZER_URL;
export const LPR_SERVER_URL = window.REACT_APP_LPR_SERVER_URL;
export const LALAMOVE_DISPATCH_ENABLED = window.REACT_APP_LALAMOVE_DISPATCH_ENABLED;
export const AGENT_ADMIN_URL = window.REACT_APP_AGENT_ADMIN_URL;
export const PARKIT_WEB_URL = window.REACT_APP_PARKIT_WEB_URL;
export const CAMPAIGN_API_BASE_URL = window.REACT_APP_CAMPAIGN_API_BASE_URL;

export function isRouteOptimizationEnabled() {
  return !!ROUTE_OPTIMIZER_URL;
}

export function isEmailCampaignEnabled() {
  return !!CAMPAIGN_API_BASE_URL;
}

export function isPermissionsEnabled() {
  const value = window.REACT_APP_PERMISSIONS_ENABLED;
  return value === true || value === "true";
}

export function isLalamoveDispatchEnabled() {
  return LALAMOVE_DISPATCH_ENABLED === true || LALAMOVE_DISPATCH_ENABLED === "true";
}

export function centToDollar(dollar = 0) {
  return (dollar / 100).toFixed(2);
}

export const dollarToCent = (dollar) => Number((dollar * 100).toFixed(0));

export const addFilter = (list, key, value) => {
  if (value) {
    list.push(`${key}:${value}`);
  }
  return list;
};

export const addFilterWithRange = (list, key, startRange, endRange) => {
  if (startRange && endRange) {
    list.push(`${key}:${startRange}:${endRange}`);
  }
  return list;
};

export const formatCurrency = (currency) => {
  switch (currency) {
    case "MYR":
      return "RM";
    case "SGD":
      return "S$";
    case "HKD":
      return "HK$";
    default:
      return "RM";
  }
};

export const calculateDifferenceInDays = (date) => {
  if (!date) return null;
  const startDate = new Date(date);
  if (isNaN(startDate)) return null;
  const differenceInMs = new Date() - startDate;
  return Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
};

export const hasVehicleChanged = (originalVehicle, updatedVehicle) => {
  return (
    originalVehicle.registrationNumber !== updatedVehicle.registrationNumber ||
    originalVehicle.model !== updatedVehicle.model ||
    originalVehicle.color !== updatedVehicle.color
  );
};

export const extractCountryCodeAndLocalNumber = (fullNumber, countries) => {
  if (!fullNumber) return { countryCode: "MY", localNumber: "" };

  const match = countries.find(({ phone }) =>
    fullNumber.startsWith(phone)
  );
  if (match) {
    return {
      countryCode: match.code,
      localNumber: fullNumber.replace(match.phone, ""),
    };
  }

  return {
    countryCode: "MY",
    localNumber: fullNumber,
  };
};

/**
 * Deduces car insurance status based on submitted flag, effective date, and expiry date
 * @param {boolean} submitted - Whether the insurance has been submitted
 * @param {string|Date} effectiveDate - The effective date of the insurance
 * @param {string|Date} expirationDate - The expiration date of the insurance
 * @returns {string} - The deduced status: DRAFT, RENEWABLE, ACTIVE, or EXPIRED
 */
export const deduceCarInsuranceStatus = (submitted, effectiveDate, expirationDate) => {
  // If not submitted, status is DRAFT
  if (!submitted) {
    return "DRAFT";
  }

  // If submitted but no dates, cannot determine status
  if (!effectiveDate || !expirationDate) {
    return "DRAFT";
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const startDate = new Date(effectiveDate);
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(expirationDate);
  endDate.setHours(0, 0, 0, 0);

  // Calculate 90 days before expiry date
  const renewableDate = new Date(endDate);
  renewableDate.setDate(renewableDate.getDate() - 90);

  // Submitted policies are considered active even before their effective date.
  if (today < startDate) {
    return "ACTIVE";
  }

  // If today is after expiry date, insurance is expired
  if (today > endDate) {
    return "EXPIRED";
  }

  // If today is within 90 days before expiry date, insurance is renewable
  if (today >= renewableDate && today <= endDate) {
    return "RENEWABLE";
  }

  // If today is between effective date and 90 days before expiry, insurance is active
  if (today >= startDate && today < renewableDate) {
    return "ACTIVE";
  }

  return "DRAFT";
};
